import { Link } from 'react-router-dom'
import { getMediaBaseUrl, getMediaUrl } from './mediaHelpers'

export function getEventImage(event) {
  if (event.image) {
    if (event.image.startsWith('http')) return event.image
    return `${getMediaBaseUrl()}${event.image}`
  }
  if (event.media && event.media.length > 0) {
    const firstImageMedia = event.media.find((m) => m.type === 'image')
    if (firstImageMedia) return getMediaUrl(firstImageMedia.url)
  }
  return `${getMediaBaseUrl()}/uploads/events/default-event.jpg`
}

export function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString('en-IN', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
  })
}

export function formatTime(dateStr) {
  return new Date(dateStr).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })
}

export function formatDateRange(startDateStr, endDateStr) {
  const start = new Date(startDateStr)
  if (!endDateStr) return formatDate(startDateStr)
  const end = new Date(endDateStr)
  if (start.toDateString() === end.toDateString()) return formatDate(startDateStr)
  const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()
  if (sameMonth) {
    const startPart = start.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric' })
    const endPart = end.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' })
    return `${startPart} - ${endPart}`
  }
  const startPart = start.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'long' })
  const endPart = end.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' })
  return `${startPart} - ${endPart}`
}

export function getFormatBadgeColor(format) {
  switch ((format || '').toLowerCase()) {
    case 'online': return 'bg-blue-100 text-blue-800'
    case 'in-person': return 'bg-green-100 text-green-800'
    case 'hybrid': return 'bg-purple-100 text-purple-800'
    default: return 'bg-gray-100 text-gray-800'
  }
}

export function getLocationText(event) {
  if (event.space) {
    return event.space.name + (event.space.city ? `, ${event.space.city}` : '')
  }
  return event.location || (event.format === 'online' ? 'Online' : 'Location TBA')
}

export function getFacilitatorNames(event) {
  const names = []
  if (event.facilitators?.length) names.push(...event.facilitators.map((f) => f.name))
  if (event.externalFacilitators?.length) names.push(...event.externalFacilitators)
  return names
}

export function renderFacilitatorLinks(
  event,
  stopPropagation = false,
  linkClassName = 'text-primary-600 underline font-semibold hover:text-primary-700 transition-colors'
) {
  const elements = []
  if (event.facilitators?.length) {
    event.facilitators.forEach((f, index) => {
      if (elements.length > 0) elements.push(<span key={`sep-${index}`}>, </span>)
      if (f.slug) {
        elements.push(
          <Link
            key={`fac-${f.id || index}`}
            to={`/facilitator/${f.slug}`}
            className={linkClassName}
            onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
          >
            {f.name}
          </Link>
        )
      } else {
        elements.push(<span key={`fac-${f.id || index}`}>{f.name}</span>)
      }
    })
  }
  if (event.externalFacilitators?.length) {
    event.externalFacilitators.forEach((name, index) => {
      if (elements.length > 0) elements.push(<span key={`ext-sep-${index}`}>, </span>)
      elements.push(<span key={`ext-${index}`}>{name}</span>)
    })
  }
  return elements
}
